/**
 * Checks if a given value is a function.
 *
 * @param value The value to check if it is a function.
 * @returns Returns `true` if `value` is a function, else `false`.
 *
 * @example
 * isFunction(() => {}); // true
 * isFunction(async () => {}); // true
 * isFunction('abc'); // false
 */
export function isFunction<T>(
  value: T
): value is T & ((...args: any[]) => any) {
  return typeof value === 'function';
}
